import $ from 'jquery';
import pageScripts from './pages';

import 'what-input';

$(document).ready(function () {
    //Require all components here.
    require("./components/top-navigation");
    require("./components/off-canvas-menu");
    require("./components/carousel");
    require("./components/clickable");
    require("./components/collapse");
    require("./components/header-search");
    require("./components/associates");
    require("./components/facts_and_numbers");
    require("./components/submenu");
    
    const $form = $('.mpForm');

    function displayForm() {
        $form.css('display', 'block');
        $(window).off('scroll', scrollHandler);
    }

    function scrollHandler() {
        if ($form.css('display') === 'none') {
            displayForm();
        }
    }

    $(window).on('scroll', scrollHandler);



    let $confirmation = $('.gform_confirmation_wrapper ');
    if ($confirmation.length > 0) {
        document.querySelector(".gform_confirmation_wrapper").scrollIntoView({behavior: "smooth"});
    }

    let lastScroll = 0;

    window.addEventListener("scroll", () => {
        const currentScroll = window.scrollY;
        if (currentScroll <= 0) {
            document.body.classList.remove('sticky');
            return;
        } else {
            document.body.classList.add('sticky');
        }

    });

    document.body.className.replace(/-/g, '_').split(/\s+/).forEach(cls => {
        pageScripts[cls] && pageScripts[cls]();
    });

});


$(document).on('facetwp-refresh', function () {
    if (FWP.soft_refresh === true) {
        FWP.enable_scroll = true;
    } else {
        FWP.enable_scroll = false;
    }
});
$(document).on('facetwp-loaded', function () {
    if (FWP.enable_scroll === true) {
        $('html, body').animate({
            scrollTop: $('.flexible-header.flexible-header--archive.actions').offset().top - 120
        }, 350);
    }
});